import { useState } from 'react'

import { captureException, captureMessage, withErrorBoundary } from '@sentry/react'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { RouterSheetWithDirtyCheck } from '@/components/atoms/Sheet/RouterSheetWithDirtyCheck'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { AdminPromotionPage } from '@/pages/promotions/AdminPromotionPage'
import { AdminPromotionUpdateFormPage } from '@/pages/promotions/forms/AdminPromotionUpdateFormPage'
import { promotion as promotionQuery } from '@/state/promotions/promotion'

export const PromotionListWithFormComponent = () => {
  const { promotionId } = Route.useParams()
  const [isDirty, setIsDirty] = useState(false)

  return (
    <>
      <AdminPromotionPage />
      <RouterSheetWithDirtyCheck className="h-full w-[600px]" isDirty={isDirty}>
        <AdminPromotionUpdateFormPage key={promotionId} onDirtyChange={setIsDirty} />
      </RouterSheetWithDirtyCheck>
    </>
  )
}

export const Route = createFileRoute('/promotions/$initiativeId/national/$promotionId')({
  component: withErrorBoundary(PromotionListWithFormComponent, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context, params }) => {
    const { exists } = await context.queryClient.fetchQuery(promotionQuery(params.promotionId))
    if (!exists) {
      captureMessage(`Promotion ${params.promotionId} not found`, { extra: { params } })
      throw redirect({ from: Route.fullPath, to: '..' })
    }
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
